module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Snow#2-895f63f6512d5c59ca6774f62f032eb0.svg";